module.exports = __webpack_public_path__ + "static/media/Barlow-BoldItalic.89c7a6be.ttf";